import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import { PayoutService } from 'src/app/services/payout.service';
import { FormControl, Validators } from '@angular/forms';
import * as uuid from 'uuid';
@Component({
  selector: 'app-pay-out-bulk-update-file-details',
  templateUrl: './pay-out-bulk-update-file-details.component.html',
  styleUrls: ['./pay-out-bulk-update-file-details.component.scss']
})
export class PayOutBulkUpdateFileDetailsComponent implements OnInit {
  viewid:any;
  rows:any;
  Transactiondetail:boolean=false;
  constructor(private route: ActivatedRoute,private service: PayoutService, private commonfunction: CommonFunctionService,private router:Router) {
    this.route.params.subscribe(params => {
      this.viewid = params['Id'];
     
    });
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.BulkUploadFilesviewdetail(this.viewid , merchantdata.MerchantKeyId).subscribe(result => {
      this.rows=result;
      if(this.rows.Status == 3)
      {
        this.Transactiondetail=true;
      }
      else{
        this.Transactiondetail=false;
      }
    });

   }

  ngOnInit() {
  }

}
